import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import { env } from "@/lib/env";

/**
 * Singleton Supabase client. Use this instead of creating ad-hoc clients so
 * auth state (the access token hitting the Fly-hosted intelligence API) is
 * shared across hooks and components.
 */
export const supabase: SupabaseClient = createClient(env.SUPABASE_URL, env.SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});
